// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireProviderLogo__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireProviderLogo.scss
 ** module id = 901
 ** module chunks = 1
 **/